import { Controller } from "@hotwired/stimulus"

// Shows the "on" targets while the checkbox is ticked and the "off" targets
// while it is clear. Used by settings rows that reveal a value field and by
// the no-show dialog's email note.
export default class extends Controller {
  static targets = ["checkbox", "on", "off"]

  connect() {
    this.sync()
  }

  sync() {
    const checked = this.hasCheckboxTarget && this.checkboxTarget.checked
    this.onTargets.forEach((element) => element.classList.toggle("hidden", !checked))
    this.offTargets.forEach((element) => element.classList.toggle("hidden", checked))
  }
}
